import api, { ApiResponse } from './api'

export interface CurrencyOption {
  code: string
  label: string
}

export interface CurrenciesResponse {
  currencies: CurrencyOption[]
  defaultCurrency: string
}

export function getCurrencies(): Promise<ApiResponse<CurrenciesResponse>> {
  return api.get('/v1/config/currencies')
}

export interface SettlementConfigResponse {
  settlementDays: number
}

export function getSettlementConfig(): Promise<ApiResponse<SettlementConfigResponse>> {
  return api.get('/v1/config/settlement')
}

export interface LegalConfigResponse {
  legalTermsVersion: string
  legalUserAgreementUrl: string
  legalPrivacyPolicyUrl: string
  legalDisclaimerUrl: string
  legalAupUrl: string
}

export function getLegalConfig(): Promise<ApiResponse<LegalConfigResponse>> {
  return api.get('/v1/config/legal')
}
